module.exports = __webpack_public_path__ + "static/media/cafe.ae9ad27a.png";